import { getBuildBetaAccess, getIsOwnerApp } from './app-state.js';

/** Пока в бете — у клиентов только консультация; owner без ограничений. */
export const BETA_READY_BUILDS_ONLY = true;

const LIVE_CUSTOMER_ACTIONS = new Set(['consult']);
const BUILD_BETA_ACTIONS = new Set(['build', 'build_yes', 'build_no']);

const WIP_CUSTOMER_ACTIONS = new Set([
  'build',
  'build_yes',
  'build_no',
  'upgrade',
  'presets',
  'ai_assistant'
]);

export function isBetaReadyBuildsOnly(): boolean {
  return BETA_READY_BUILDS_ONLY && !getIsOwnerApp();
}

export function isCustomerActionLive(action: string): boolean {
  if (!action) return true;
  if (!isBetaReadyBuildsOnly()) return true;
  if (LIVE_CUSTOMER_ACTIONS.has(action)) return true;
  if (getBuildBetaAccess() && BUILD_BETA_ACTIONS.has(action)) return true;
  if (WIP_CUSTOMER_ACTIONS.has(action)) return false;
  return true;
}

export function isCustomerPortfolioLive(): boolean {
  return !isBetaReadyBuildsOnly();
}
